module.exports = __webpack_public_path__ + "static/svg-cards-ee03ae14955f0b10b6c060a800ccb08d.svg";